// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__VvOYi","form":"Contact_form__fXePt","image":"Contact_image__LB4ng","message":"Contact_message__6nyPH","errorMessage":"Contact_errorMessage__DNieE"};